import i18n, { type Config } from 'sveltekit-i18n';

export const defaultLocale = 'en';

interface Params {
	[key: string]: string | number | boolean | undefined | null;
	// add more parameters that are used here
}

const myConfig: Config<Params> = {
	loaders: [
		// COMMON
		{
			locale: 'en',
			key: 'common',
			loader: async () => (await import('../i18n/en/common.json')).default
		},
		{
			locale: 'fr',
			key: 'common',
			loader: async () => (await import('../i18n/fr/common.json')).default
		},
		{
			locale: 'nl',
			key: 'common',
			loader: async () => (await import('../i18n/nl/common.json')).default
		},

		// report
		{
			locale: 'fr',
			routes: [/report/, /summary/],
			key: 'report',
			loader: async () => (await import('../i18n/fr/report.json')).default
		},
		{
			locale: 'en',
			routes: [/report/, /summary/],
			key: 'report',
			loader: async () => (await import('../i18n/en/report.json')).default
		},
		{
			locale: 'nl',
			routes: [/report/, /summary/],
			key: 'report',
			loader: async () => (await import('../i18n/nl/report.json')).default
		},

		{
			locale: 'fr',
			key: 'medical',
			loader: async () => (await import('../i18n/fr/medical.json')).default
		},
		{
			locale: 'en',
			key: 'medical',
			loader: async () => (await import('../i18n/en/medical.json')).default
		},
		{
			locale: 'nl',
			key: 'medical',
			loader: async () => (await import('../i18n/nl/medical.json')).default
		},

		//LEGAL

		{
			locale: 'en',
			key: 'legal',
			loader: async () => (await import('../i18n/en/legal')).default
		},
		{
			locale: 'fr',
			key: 'legal',
			loader: async () => (await import('../i18n/fr/legal')).default
		},
		{
			locale: 'nl',
			key: 'legal',
			loader: async () => (await import('../i18n/nl/legal')).default
		},

		//LOGIN

		{
			locale: 'en',
			key: 'login',
			routes: [/^\/login/],
			loader: async () => (await import('../i18n/en/login.json')).default
		},
		{
			locale: 'fr',
			key: 'login',
			routes: [/^\/login/],
			loader: async () => (await import('../i18n/fr/login.json')).default
		},
		{
			locale: 'nl',
			key: 'login',
			routes: [/^\/login/],
			loader: async () => (await import('../i18n/nl/login.json')).default
		},

		// QUESTIONNAIRE
		{
			locale: 'en',
			key: 'profile',
			routes: ['/profile'],
			loader: async () => (await import('../i18n/en/profile.json')).default
		},
		{
			locale: 'fr',
			key: 'profile',
			routes: ['/profile'],
			loader: async () => (await import('../i18n/fr/profile.json')).default
		},
		{
			locale: 'nl',
			key: 'profile',
			routes: ['/profile'],
			loader: async () => (await import('../i18n/nl/profile.json')).default
		},

		// Onboarding
		{
			locale: 'en',
			key: 'onboarding',
			routes: [/onboarding/, /^\/questionnaire\/([A-Za-z]+)\/onboarding\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/en/profile_questions.json')).default
		},
		{
			locale: 'fr',
			key: 'onboarding',
			routes: [/onboarding/, /^\/questionnaire\/([A-Za-z]+)\/onboarding\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/fr/profile_questions.json')).default
		},
		{
			locale: 'nl',
			key: 'onboarding',
			routes: [/questionnaire/, /^\/questionnaire\/([A-Za-z]+)\/onboarding\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/nl/profile_questions.json')).default
		},
		// Medical History
		{
			locale: 'en',
			key: 'medical_history',
			routes: [
				/questionnaire/,
				/booking/,
				/^\/questionnaire\/checkup\/medicalHistory\/([A-Za-z]+)/
			],
			loader: async () => (await import('../i18n/en/medical_history_questions.json')).default
		},
		{
			locale: 'fr',
			key: 'medical_history',
			routes: [
				/questionnaire/,
				/booking/,
				/^\/questionnaire\/checkup\/medicalHistory\/([A-Za-z]+)/
			],
			loader: async () => (await import('../i18n/fr/medical_history_questions.json')).default
		},
		{
			locale: 'nl',
			key: 'medical_history',
			routes: [
				/questionnaire/,
				/booking/,
				/^\/questionnaire\/checkup\/medicalHistory\/([A-Za-z]+)/
			],
			loader: async () => (await import('../i18n/nl/medical_history_questions.json')).default
		},

		// MEDICATION
		{
			locale: 'en',
			key: 'medication',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/medication\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/en/medication_questions.json')).default
		},
		{
			locale: 'fr',
			key: 'medication',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/medication\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/fr/medication_questions.json')).default
		},
		{
			locale: 'nl',
			key: 'medication',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/medication\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/nl/medication_questions.json')).default
		},

		// CANCER
		{
			locale: 'en',
			key: 'cancer',
			routes: [
				/booking/,
				/questionnaire/,
				/^\/questionnaire\/checkup\/cancerScreening\/([A-Za-z]+)/
			],
			loader: async () => (await import('../i18n/en/cancer_questions.json')).default
		},
		{
			locale: 'fr',
			key: 'cancer',
			routes: [
				/booking/,
				/questionnaire/,
				/^\/questionnaire\/checkup\/cancerScreening\/([A-Za-z]+)/
			],
			loader: async () => (await import('../i18n/fr/cancer_questions.json')).default
		},
		{
			locale: 'nl',
			key: 'cancer',
			routes: [
				/booking/,
				/questionnaire/,
				/^\/questionnaire\/checkup\/cancerScreening\/([A-Za-z]+)/
			],
			loader: async () => (await import('../i18n/nl/cancer_questions.json')).default
		},
		// Risk factors
		{
			locale: 'en',
			key: 'risks',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/riskFactors\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/en/risks_questions.json')).default
		},
		{
			locale: 'fr',
			key: 'risks',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/riskFactors\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/fr/risks_questions.json')).default
		},
		{
			locale: 'nl',
			key: 'risks',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/riskFactors\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/nl/risks_questions.json')).default
		},

		// Immunity
		{
			locale: 'en',
			key: 'immunity',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/immunity\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/en/immunity_questions.json')).default
		},
		{
			locale: 'fr',
			key: 'immunity',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/immunity\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/fr/immunity_questions.json')).default
		},
		{
			locale: 'nl',
			key: 'immunity',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/immunity\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/nl/immunity_questions.json')).default
		},

		// Nutrition
		{
			locale: 'en',
			key: 'nutrition',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/nutrition\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/en/nutrition_questions.json')).default
		},
		{
			locale: 'fr',
			key: 'nutrition',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/nutrition\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/fr/nutrition_questions.json')).default
		},
		{
			locale: 'nl',
			key: 'nutrition',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/nutrition\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/nl/nutrition_questions.json')).default
		},
		// Lifestyle

		{
			locale: 'en',
			key: 'lifestyle',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/lifestyle\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/en/lifestyle_questions.json')).default
		},
		{
			locale: 'fr',
			key: 'lifestyle',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/lifestyle\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/fr/lifestyle_questions.json')).default
		},
		{
			locale: 'nl',
			key: 'lifestyle',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/lifestyle\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/nl/lifestyle_questions.json')).default
		},

		// SPORT

		{
			locale: 'en',
			key: 'sport',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/sport\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/en/sport_questions.json')).default
		},
		{
			locale: 'fr',
			key: 'sport',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/sport\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/fr/sport_questions.json')).default
		},
		{
			locale: 'nl',
			key: 'sport',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/sport\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/nl/sport_questions.json')).default
		},
		// SLEEP
		{
			locale: 'en',
			key: 'sleep_questions',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/sleep\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/en/sleep_questions.json')).default
		},
		{
			locale: 'fr',
			key: 'sleep_questions',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/sleep\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/fr/sleep_questions.json')).default
		},
		{
			locale: 'nl',
			key: 'sleep_questions',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/sleep\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/nl/sleep_questions.json')).default
		},
		// MENTAL
		{
			locale: 'en',
			key: 'mental',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/mental\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/en/mental_questions.json')).default
		},
		{
			locale: 'fr',
			key: 'mental',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/mental\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/fr/mental_questions.json')).default
		},
		{
			locale: 'nl',
			key: 'mental',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/mental\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/nl/mental_questions.json')).default
		},

		// Extra
		{
			locale: 'en',
			key: 'extra',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/extra\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/en/extra.json')).default
		},
		{
			locale: 'fr',
			key: 'extra',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/extra\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/fr/extra.json')).default
		},
		{
			locale: 'nl',
			key: 'extra',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/checkup\/extra\/([A-Za-z]+)/],
			loader: async () => (await import('../i18n/nl/extra.json')).default
		},

		// CHAT
		{
			locale: 'en',
			key: 'chat',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/([A-Za-z]+)\/medicalHistory\/type/],
			loader: async () => (await import('../i18n/en/chat.json')).default
		},
		{
			locale: 'fr',
			key: 'chat',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/([A-Za-z]+)\/medicalHistory\/type/],
			loader: async () => (await import('../i18n/fr/chat.json')).default
		},
		{
			locale: 'nl',
			key: 'chat',
			routes: [/booking/, /questionnaire/, /^\/questionnaire\/([A-Za-z]+)\/medicalHistory\/type/],
			loader: async () => (await import('../i18n/nl/chat.json')).default
		},
		// FOLLOWUP
		{
			locale: 'en',
			key: 'followup',
			routes: [/followup/],
			loader: async () => (await import('../i18n/en/followup.json')).default
		},
		{
			locale: 'fr',
			key: 'followup',
			routes: [/followup/],
			loader: async () => (await import('../i18n/fr/followup.json')).default
		},
		{
			locale: 'nl',
			key: 'followup',
			routes: [/followup/],
			loader: async () => (await import('../i18n/nl/followup.json')).default
		},

		// BOOKING
		{
			locale: 'en',
			key: 'booking',
			routes: [/followup/, /booking/, /questionnaire/],
			loader: async () => (await import('../i18n/en/booking')).default
		},
		{
			locale: 'fr',
			key: 'booking',
			routes: [/followup/, /booking/, /questionnaire/],
			loader: async () => (await import('../i18n/fr/booking')).default
		},
		{
			locale: 'nl',
			key: 'booking',
			routes: [/followup/, /booking/, /questionnaire/],
			loader: async () => (await import('../i18n/nl/booking')).default
		},
		// REVIEW / confirmation
		{
			locale: 'en',
			key: 'review',
			routes: [
				/booking/,
				/^\/questionnaire/,
				/^\/questionnaire\/([A-Za-z]+)\/confirmation\/([A-Za-z]+)/
			],
			loader: async () => (await import('../i18n/en/review.json')).default
		},
		{
			locale: 'fr',
			key: 'review',
			routes: [
				/booking/,
				/^\/questionnaire/,
				/^\/questionnaire\/([A-Za-z]+)\/confirmation\/([A-Za-z]+)/
			],
			loader: async () => (await import('../i18n/fr/review.json')).default
		},
		{
			locale: 'nl',
			key: 'review',
			routes: [
				/booking/,
				/^\/questionnaire/,
				/^\/questionnaire\/([A-Za-z]+)\/confirmation\/([A-Za-z]+)/
			],
			loader: async () => (await import('../i18n/nl/review.json')).default
		},

		// Practitioner
		{
			locale: 'fr',
			key: 'practitioner.common',
			routes: [/practitioner/],
			loader: async () => (await import('../i18n/fr/practitioner/common.json')).default
		},
		{
			locale: 'fr',
			key: 'practitioner.medical',
			routes: [/practitioner/],
			loader: async () => (await import('../i18n/fr/practitioner/medical.json')).default
		}
	]
};

export const {
	t,
	locale,
	locales,
	loading,
	loadTranslations,
	translations,
	addTranslations,
	setLocale,
	setRoute
} = new i18n(myConfig);
